import { useQuery } from 'data-fetching-client';
import { GET_OBJECT_TYPE_DEFINITION } from '../api/objectTypeDefinition';
export const useObjectTypeDefinition = objectTypeId => {
  const {
    data,
    loading
  } = useQuery(GET_OBJECT_TYPE_DEFINITION, {
    variables: {
      objectTypeId
    }
  });
  return {
    objectTypeDefinition: data === null || data === void 0 ? void 0 : data.objectTypeDefinition,
    loading
  };
};